module.exports = __webpack_public_path__ + "static/img/IMG_0587.95bf7f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/items/dijak-es-ermek/IMG_0587.jpg
// module id = 551
// module chunks = 0